// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-footer[data-v-3899e4d3] {
  display: block;
  text-align: center;
}
ul[data-v-3899e4d3] {
  list-style-type: none;
  padding-left: 5px;
}
.icon-download[data-v-3899e4d3] {
  text-decoration: none !important;
}
.icon-download[data-v-3899e4d3]:before {
  margin-right: 5px;
  vertical-align: middle;
  color: #444444;
}
`, "",{"version":3,"sources":["webpack://./public/pages/dialogs/SubmitSuccess.3.vue","webpack://./../SubmitSuccess.3.vue"],"names":[],"mappings":"AACA;EACI,cAAA;EACA,kBAAA;ACAJ;ADEA;EACI,qBAAA;EACA,iBAAA;ACAJ;ADEA;EACI,gCAAA;ACAJ;ADCI;EACI,iBAAA;EACA,sBAAA;EACA,cAAA;ACCR","sourcesContent":["\n.modal-footer {\n    display: block;\n    text-align: center;\n}\nul {\n    list-style-type: none;\n    padding-left: 5px;\n}\n.icon-download {\n    text-decoration: none !important;\n    &:before {\n        margin-right: 5px;\n        vertical-align: middle;\n        color: #444444;\n    }\n}\n",".modal-footer {\n  display: block;\n  text-align: center;\n}\nul {\n  list-style-type: none;\n  padding-left: 5px;\n}\n.icon-download {\n  text-decoration: none !important;\n}\n.icon-download:before {\n  margin-right: 5px;\n  vertical-align: middle;\n  color: #444444;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
